import 'regenerator-runtime/runtime';
import 'build/babelHelpers';
import 'utils/Url';

import 'whatwg-fetch';
import 'core-js/fn/object/assign';
import 'core-js/fn/promise';
import 'core-js/fn/symbol';
import 'performance-polyfill';
import 'utils/shims/ObjectValues';
import runApplication from 'utils/framework/main';

runApplication();
